import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { Button, Col, Row } from "reactstrap";

import { BsWallet2 } from "react-icons/bs";
import {
  FaExchangeAlt,
  FaMoneyBillWave
} from "react-icons/fa";
import { FaMoneyBillTransfer, FaRegMoneyBill1 } from "react-icons/fa6";
import { IoCashOutline } from "react-icons/io5";
import { encryptStorage } from "../../constants/EncryptStorage";
import { GetLanguageString } from "../helper/Components";
import { isUsraRole } from "../helper/Method";
import { ApiFinance } from "./ApiFinance";
import { CashAccountBalanceCard, AmanatAccountBalanceCard } from "./BalanceCards";

const QuickManageFund = ({ history }) => {
  const unitTypeName = encryptStorage.getItem("unitTypeName");
  const loggedInUnitId = parseInt(encryptStorage.getItem("loggedInUnitId"));
  const [balances, setBalances] = useState({
    cashAccountBalance: 0,
    amanatAccountBalance: 0,
  });
  const [loadingBalances, setLoadingBalances] = useState(true);

  useEffect(() => {
    ApiFinance()
      .GetCashToAmanatTransferData(loggedInUnitId)
      .then((res) => {
        if (res.data) {
          setBalances({
            cashAccountBalance: res.data.cashAccountBalance || 0,
            amanatAccountBalance: res.data.amanatAccountBalance || 0,
          });
        }
      })
      .catch((err) => {
        console.error("Error fetching balances in QuickManageFund:", err);
      })
      .finally(() => {
        setLoadingBalances(false);
      });
  }, [loggedInUnitId]);

  return (
    <>
      <div className="wrapper wrapper-content wrapper-custom">
        {/* Elegant side-by-side KPI Balance Cards */}
        <Row style={{ marginBottom: "15px" }}>
          <CashAccountBalanceCard
            balance={balances.cashAccountBalance}
            loading={loadingBalances}
            colProps={{ md: "6", sm: "12", className: "mb-3" }}
          />
          <AmanatAccountBalanceCard
            balance={balances.amanatAccountBalance}
            loading={loadingBalances}
            colProps={{ md: "6", sm: "12", className: "mb-3" }}
          />
        </Row>

        <div className="ibox">
          <div className="ibox-content panel-body">
            <h3>{<GetLanguageString props="transactions_income" />}</h3>

            <Row>
              <Col xl="1" className="text-center">
                <Button
                  className="btn-danger dim btn-large-dim"
                  onClick={() =>
                    history.push({
                      pathname: `/funds/addInfaqCashInHand`,
                    })
                  }
                >
                  <FaRegMoneyBill1 size={50} />
                </Button>
                <h4>
                  {
                    <GetLanguageString props="transactions_infaq_to_cash_in_hand" />
                  }
                </h4>
              </Col>

              <Col xl="1" className="text-center">
                <Button
                  className="btn-info dim btn-large-dim"
                  onClick={() =>
                    history.push({
                      pathname: `/funds/addInfaqAmanatAccount`,
                    })
                  }
                >
                  <FaRegMoneyBill1 size={50} />
                </Button>
                <h4>
                  {
                    <GetLanguageString props="transactions_infaq_to_amanat_account" />
                  }
                </h4>
              </Col>

              <Col xl="1" className="text-center">
                <Button
                  className="btn-success dim btn-large-dim"
                  onClick={() =>
                    history.push({
                      pathname: `/funds/addBulkInfaq`,
                    })
                  }
                >
                  <FaMoneyBillWave size={50} />
                </Button>
                <h4>{<GetLanguageString props="funds_add_bulk_fund" />}</h4>
              </Col>

              <Col xl="1" className="text-center">
                <Button
                  className="btn-primary dim btn-large-dim"
                  onClick={() =>
                    history.push({
                      pathname: `/funds/manageIncome`,
                    })
                  }
                >
                  <BsWallet2 size={50} />
                </Button>
                <h4>{<GetLanguageString props="manage_income" />}</h4>
              </Col>
              {!isUsraRole() && (
                <>
                  <Col xl="1" className="text-center">
                    <Button
                      className="btn-success dim btn-large-dim"
                      onClick={() =>
                        history.push({
                          pathname: `/funds/otherIncome`,
                        })
                      }
                    >
                      <IoCashOutline size={50} />
                    </Button>
                    <h4>{<GetLanguageString props="funds_other_income" />}</h4>
                  </Col>
                  {unitTypeName === "Halqa" && (
                    <Col xl="1" className="text-center">
                      <Button
                        className="btn-warning dim btn-large-dim"
                        onClick={() =>
                          history.push({
                            pathname: `/funds/otherIncomeLoanFromMarkaz`,
                          })
                        }
                      >
                        <IoCashOutline size={50} />
                      </Button>
                      <h4>
                        {
                          <GetLanguageString props="funds_other_income_loan_from_markaz" />
                        }
                      </h4>
                    </Col>
                  )}
                  {unitTypeName === "Halqa" && (
                    <>
                      <Col xl="1" className="text-center">
                        <Button
                          className="btn-primary dim btn-large-dim"
                          onClick={() =>
                            history.push({
                              pathname: `/funds/OtherIncomeTarbiatiCourseReimbursment`,
                            })
                          }
                        >
                          <IoCashOutline size={50} />
                        </Button>
                        <h4>
                          {
                            <GetLanguageString props="funds_other_income_tarbiati_course_reimbursment" />
                          }
                        </h4>
                      </Col>
                      <Col xl="1" className="text-center">
                        <Button
                          className="btn-success dim btn-large-dim"
                          onClick={() =>
                            history.push({
                              pathname: `/funds/otherIncomeHelpFromMuqamiTanzeem`,
                            })
                          }
                        >
                          <IoCashOutline size={50} />
                        </Button>
                        <h4>
                          {
                            <GetLanguageString props="funds_other_income_assistance_from_muqami_tanzeem" />
                          }
                        </h4>
                      </Col>
                    </>
                  )}
                  <Col xl="1" className="text-center">
                    <Button
                      className="btn-warning dim btn-large-dim"
                      onClick={() =>
                        history.push({
                          pathname: `/funds/assetDonation`,
                        })
                      }
                    >
                      <IoCashOutline size={50} />
                    </Button>
                    <h4>
                      {<GetLanguageString props="funds_asset_donation" />}
                    </h4>
                  </Col>
                </>
              )}
            </Row>
          </div>
        </div>
      </div>

      {!isUsraRole() && (
        <div
          style={{ marginTop: "-50px", padding: "5px" }}
          className="wrapper wrapper-content wrapper-custom"
        >
          <div className="ibox">
            <div className="ibox-content panel-body">
              <h3>{<GetLanguageString props="sidebar_funds_expenses" />}</h3>

              <Row>
                <Col xl="1" className="text-center">
                  <Button
                    className="btn-success dim btn-large-dim"
                    onClick={() =>
                      history.push({
                        pathname: `/funds/expenseFromCashInHand`,
                      })
                    }
                  >
                    <IoCashOutline size={50} />
                  </Button>
                  <h4>
                    {
                      <GetLanguageString props="finance_expense_cash_in_hand" />
                    }
                  </h4>
                </Col>
                <Col xl="1" className="text-center">
                  <Button
                    className="btn-info dim btn-large-dim"
                    onClick={() =>
                      history.push({
                        pathname: `/funds/expenseFromAmanat`,
                      })
                    }
                  >
                    <IoCashOutline size={50} />
                  </Button>
                  <h4>
                    {
                      <GetLanguageString props="finance_expense_amanat_account" />
                    }
                  </h4>
                </Col>
                {unitTypeName === "Tanzeem" && (
                  <Col xl="1" className="text-center">
                    <Button
                      className="btn-warning dim btn-large-dim"
                      onClick={() =>
                        history.push({
                          pathname: `/funds/expenseHalqaShare`,
                        })
                      }
                    >
                      <IoCashOutline size={50} />
                    </Button>
                    <h4>
                      {
                        <GetLanguageString props="funds_halqa_share" />
                      }
                    </h4>
                  </Col>
                )}
                <Col xl="1" className="text-center">
                  <Button
                    className="btn-primary dim btn-large-dim"
                    onClick={() =>
                      history.push({
                        pathname: `/funds/manageExpense`,
                      })
                    }
                  >
                    <BsWallet2 size={50} />
                  </Button>
                  <h4>{<GetLanguageString props="manage_expense" />}</h4>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      )}

      <div
        style={{ marginTop: !isUsraRole() ? "-10px" : "-50px", padding: "5px" }}
        className="wrapper wrapper-content wrapper-custom"
      >
        <div className="ibox">
          <div className="ibox-content panel-body">
            <h3>{<GetLanguageString props="transfer" />}</h3>

            <Row>
              <Col xl="1" className="text-center">
                <Button
                  className="btn-warning dim btn-large-dim"
                  onClick={() =>
                    history.push({
                      pathname: `/funds/transferCashInHandToAmanat`,
                    })
                  }
                >
                  <FaMoneyBillTransfer />
                </Button>
                <h4>
                  {
                    <GetLanguageString props="transactions_cashinhand_to_amanat_account" />
                  }
                </h4>
              </Col>
              <Col xl="1" className="text-center">
                <Button
                  className="btn-danger dim btn-large-dim"
                  onClick={() =>
                    history.push({
                      pathname: `/funds/transferAmanatToCashInHand`,
                    })
                  }
                >
                  <FaMoneyBillTransfer />
                </Button>
                <h4>
                  {
                    <GetLanguageString props="transactions_amanat_to_cash_in_hand_account" />
                  }
                </h4>
              </Col>
              {unitTypeName === "Halqa" && !isUsraRole() && (
                <Col xl="1" className="text-center">
                  <Button
                    className="btn-success dim btn-large-dim"
                    onClick={() =>
                      history.push({
                        pathname: `/funds/transferMarkazShare`,
                      })
                    }
                  >
                    <FaMoneyBillTransfer />
                  </Button>
                  <h4>
                    {
                      <GetLanguageString props="funds_markaz_share" />
                    }
                  </h4>
                </Col>
              )}
              <Col xl="1" className="text-center">
                <Button
                  className="btn-info dim btn-large-dim"
                  onClick={() =>
                    history.push({
                      pathname: `/funds/manageTransfer`,
                    })
                  }
                >
                  <FaExchangeAlt />
                </Button>
                <h4>
                  {<GetLanguageString props="transactions_manage_transfer" />}
                </h4>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouter(QuickManageFund);
